/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilters_viewer = {
    readonly isMatchedSetsEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMetal_viewer" | "SbSharedRefineMenuFilterStone_viewer" | "SbSharedRefineMenuFilterOrigin_viewer" | "SbSharedRefineMenuFilterCreator_viewer" | "SbSharedRefineMenuFilterMaterial_viewer" | "SbRespRefineMenuFilterDeliveryOptions_viewer" | "SbMobileRefineMenuFilterDeliveryOptions_viewer" | "SbRespRefineMenuFilterStoneCut_viewer" | "SbMobileRefineMenuFilterStoneCut_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilters_viewer";
};
export type SbSharedRefineMenuFilters_viewer$data = SbSharedRefineMenuFilters_viewer;
export type SbSharedRefineMenuFilters_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilters_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilters_viewer",
  "selections": [
    {
      "alias": "isMatchedSetsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableMatchedSetsFacet"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterOrigin_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDeliveryOptions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDeliveryOptions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterStoneCut_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterStoneCut_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '1230cafc984572361a4780fa530b47cc';
export default node;
